import type { ModuloWeb } from '../../nucleo/modulos-web';
import { AreaMembros } from './AreaMembros';
import { Certificado } from './Certificado';
import { Cursos } from './Cursos';
import { Progresso } from './Progresso';
import { Trilhas } from './Trilhas';
import { i18n } from './i18n';
import { buscaTreinamento } from './busca-global';

const modulo: ModuloWeb = {
  slug: 'treinamento',
  menu: 'treinamento',
  ordem: 10,
  abas: [
    { chave: 'cursos', permissao: 'treinamento.ver', componente: Cursos },
    { chave: 'trilhas', permissao: 'treinamento.ver', componente: Trilhas },
    { chave: 'progresso', permissao: 'treinamento.ver', componente: Progresso },
  ],
  rotasExtras: [
    { caminho: 'curso/:id', componente: AreaMembros },
    { caminho: 'certificado/:codigo', componente: Certificado },
  ],
  i18n,
  // Lista de 30/10 (item 10): grupos da busca da barra superior.
  buscaGlobal: buscaTreinamento,
};

export default modulo;
